import React from "react";
import { InlineAlert } from "@/features/betslip/components/parts/InlineAlert";
import { ShareEntryAction } from "@/features/entries/components/share/ShareEntryAction";
import { useSelectionAlert } from "@/features/betslip/hooks/useSelectionAlert";
import type { AlertLevel } from "@/features/betslip/types";

type SelectionAlertProps = {
  outcomeId: string;
  placement?: AlertLevel;
};

export const SelectionAlert = ({
  outcomeId,
  placement = "outcome",
}: SelectionAlertProps) => {
  const { alert, onCta, shareEntryProps } = useSelectionAlert(
    outcomeId,
    placement,
  );

  if (!alert) return null;

  return (
    <>
      <InlineAlert alert={alert} placement={placement} onCta={onCta} />
      {shareEntryProps && <ShareEntryAction {...shareEntryProps} />}
    </>
  );
};
